export const TENANT_ID = 'ptth-tufts';
export const APP_ID = 'ptth-tufts-web';

export const MASONRY = {
  ROOT_NODE_ID_HOME_PAGE: 'homePage$root',
  ROOT_NODE_ID_SUPPORT_PAGE: 'support$root',
  ROOT_NODE_ID_BEHAVIORAL_HEALTH_PAGE: 'behavioralHealthPage$root',
};
